export const getConfig = (payload) => ({
  baseURL: 'https://boards-api.greenhouse.io/v1/boards/',
  boards: {
    pt: 'hotmartcareersbr',
    en: 'hotmartcareersen',
    es: 'hotmartcareersesp',
  },
  headers: {
    'Content-Type': 'application/json',
  },
  endpoints: {
    jobs: `/jobs`,
    offices: `/offices`,
  },
  driver: 'axios',
})
